import { createAction } from '@reduxjs/toolkit';

import { ThunkWithConfirmPayload } from './types';

export const thunkWithConfirm =
  createAction<ThunkWithConfirmPayload>('app/confirm/open');
export const closeConfirm = createAction<void>('app/confirm/close');
